import { Button } from '@aqarmap/aqarmap-ui';
import { useTranslation } from 'react-i18next';
import useWindowSize from '~/hooks/useWindowSize';
import PlanCard from '~/pages/Packages/PlanCard';
import {
  getPackagesGridClass,
  PackagesGridPlanType,
} from '~/pages/Packages/utils';
import { PackageTierType } from '~/types/packagesType';
import { useNavigate } from 'react-router-dom';
import { useBreakpoint, useFullRoutes } from '~/hooks';

export default function IndividualPackages({
  plans,
  onTiersClick,
}: {
  plans: PackagesGridPlanType[];
  onTiersClick: (tiers: PackageTierType[], name: string | null) => void;
}) {
  const { t } = useTranslation('app');
  const { mobileScreen } = useBreakpoint();
  const { width } = useWindowSize();
  const totalCardsCount = plans.length + 1;
  const navigate = useNavigate();
  const { ADD_LISTING_URL } = useFullRoutes();

  return (
    <div className="layout-boundary">
      <div
        className={`layout-boundary__inner px-2x md:px-0 ${getPackagesGridClass(totalCardsCount, width)}`}
      >
        {plans.map((plan) => (
          <div
            key={plan.key}
            className="packages-card-item packages-card-item--individuals"
          >
            <PlanCard
              plan={plan}
              mobileScreen={mobileScreen}
              onTiersClick={onTiersClick}
            />
          </div>
        ))}
        <div className="packages-card-item packages-card-item--individuals ">
          <div className="packages-special-card">
            <div className="flex  flex-col gap-2x h-auto md:h-[163px]">
              <p className="text-title-4 text-black">{t('payAsYouGoTitle')}</p>

              <p className="text-body-2 text-gray__dark_2">
                {t('payAsYouGoDescription')}
              </p>
            </div>

            <Button
              variant="secondary"
              size="medium"
              className="rounded-[26px] "
              onClick={() => {
                navigate(ADD_LISTING_URL.INITIALIZE);
              }}
            >
              {t('listYourProperty')}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}
